import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { X, Printer } from 'lucide-react';
import TesserinoAbbonamento from './TesserinoAbbonamento';
import './StampaTesserino.css';

const FORMATI = [
  { id: 'grande', label: 'Grande', misure: '176 × 111 mm' },
  { id: 'medio', label: 'Medio', misure: '128 × 81 mm' },
  { id: 'tessera', label: 'Tessera', misure: '85,6 × 54 mm' },
];

/**
 * Anteprima e stampa del tesserino di un singolo abbonamento.
 * Il bordo serve da guida per il taglio.
 */
const StampaTesserino = ({ abbonamento, onClose }) => {
  const [formato, setFormato] = useState('grande');

  if (!abbonamento) return null;

  const misure = FORMATI.find((f) => f.id === formato)?.misure;

  // Il contenuto viene montato direttamente su <body>: se restasse dentro il
  // layout admin, in stampa erediterebbe l'ingombro della barra laterale e il
  // tesserino uscirebbe dal foglio.
  return createPortal(
    <div className="portale-stampa overlay-stampa fixed inset-0 bg-gray-100 z-50 overflow-y-auto">
      <div className="non-stampare sticky top-0 bg-white border-b border-gray-200 px-5 py-3 flex flex-wrap items-center justify-between gap-3 shadow-sm">
        <div>
          <h2 className="text-base font-bold text-gray-900">Tesserino abbonamento</h2>
          <p className="text-xs text-gray-500 mt-0.5">
            {abbonamento.titolare_nome || abbonamento.beneficiario_nome} · {abbonamento.codice} · {misure}
          </p>
        </div>

        <div className="flex items-center gap-3">
          <div className="flex gap-1">
            {FORMATI.map((f) => (
              <button
                key={f.id}
                onClick={() => setFormato(f.id)}
                title={f.misure}
                className={`px-3 py-1.5 text-xs rounded-lg border transition font-medium ${
                  formato === f.id
                    ? 'bg-gray-900 text-white border-gray-900'
                    : 'bg-white text-gray-600 border-gray-300 hover:border-gray-900'
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium"
            >
              <X className="w-4 h-4 inline mr-1" />
              Chiudi
            </button>
            <button
              onClick={() => window.print()}
              className="px-5 py-2 text-sm bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition font-medium"
            >
              <Printer className="w-4 h-4 inline mr-1.5" />
              Stampa
            </button>
          </div>
        </div>
      </div>

      <div className="area-stampa p-8">
        <div className="foglio-tesserino">
          <TesserinoAbbonamento abbonamento={abbonamento} formato={formato} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StampaTesserino;
